// extracted by mini-css-extract-plugin
export default {"container":"l3U3mSFCFDjG3rx34Rdg","widgetsContainer":"ZKGVl3nzZ2lmVvup9ALn","row":"PhDyDcXFtC6Kwl8SP5km"};